<template>
  <div class="athena-collections container">
    <v-nav-bar :title="$t('comment.collections')" />
    <h5 class="title title_font2 text-center">{{ $t('venue.productList.all_collections') }}</h5>
    <div class="collections-list">
      <div class="row p-1-7d5">
        <div
          v-for="list in cates.data"
          :key="list.term_taxonomy_id"
          class="p-1-7d5 p-md-1-15"
          :class="{
            'col-md-3 col-6': cates_layout === '4columns',
            'col-md-4 col-6': cates_layout === '3columns',
            'col-md-1-5 col-6': cates_layout === '5columns',
          }"
        >
          <v-collections-card :list="list" :layout="cates_layout" card_animate="overlap" />
        </div>
      </div>
      <v-paging
        style="width: 100%"
        v-if="cates.last_page > 1"
        :total="cates.last_page"
        :currentPage="cates.current_page"
        :path="cates.path"
        theme="showtime"
        type="sort"
      ></v-paging>
    </div>
  </div>
</template>
<script>
import vPaging from '@/views/venue/js/view/collections/Paging'
export default {
  props: ['cates', 'cates_layout'],
  components: {
    vPaging,
  },
  methods: {
    page(e) {
      window.open(this.replaceSearch('page', e), '_self')
    },
  },
}
</script>

<style lang="scss" scoped>
.athena-collections {
  margin-bottom: 100px;
  .title {
    font-size: 36px;
    font-weight: bold;
    color: #222222;
    line-height: 36px;
    margin-bottom: 40px;
  }
}
@media screen and (max-width: 767px) {
  .athena-collections {
    margin-bottom: 50px;
    .title {
      font-size: 18px;
      margin-bottom: 20px;
    }
  }
}
</style>
